/* eslint-disable no-unused-vars */
import React from 'react'
import { Badge, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import translate from '../../../helper/translate'
import Formatter from '../../../helper/formatter'
import { columnResource } from '../../../helper/translatePage/languageResource'
import dataType from '../../../helper/constant/dataType'

const whitelistIpLogin = (actionFunction, languange) => ({
  key: 'id_agen_ip',
  columns: [
    {
      name: 'id',
      selector: 'id',
      sortable: false,
      type: dataType.STRING,
      showFilter: false,
      omit: true,
    },
    {
      name: 'IP Address',
      selector: 'ip_address',
      sortable: false,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Status',
      selector: 'is_active',
      sortable: false,
      cell: (row) => {
        let word
        let color
        if (row.is_active) {
          word = translate('active', languange, columnResource)
          color = 'success'
        } else {
          word = translate('notActive', languange, columnResource)
          color = 'danger'
        }
        return <Badge variant={color}>{word}</Badge>
      },
      type: dataType.ENUM,
      showFilter: true,
      default_value: [
        {
          id: false,
          name: translate('notActive', languange, columnResource),
        },
        {
          id: true,
          name: translate('active', languange, columnResource),
        },
      ],
    },
    {
      name: translate('action', languange, columnResource),
      cell: (row) => {
        return (
          <div style={{ flexDirection: 'column' }}>
            <div>
              <Button
                size="sm"
                variant="outline-info"
                className="mr-1"
                data-action="update"
                onClick={(e) => actionFunction(row, e)}
              >
                <FontAwesomeIcon fixedWidth icon={faPencilAlt} />
              </Button>
            </div>
          </div>
        )
      },
      showFilter: false,
    },
  ],
})

export default whitelistIpLogin
